module.exports = __webpack_public_path__ + "static/media/sample_marriagecertificate.a6a1aef7.jpg";